import { render, staticRenderFns } from "./DrawArea.vue?vue&type=template&id=73ccc4aa&lang=pug"
import script from "./DrawArea.vue?vue&type=script&lang=js"
export * from "./DrawArea.vue?vue&type=script&lang=js"
import style0 from "./DrawArea.vue?vue&type=style&index=0&id=73ccc4aa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports